import crud_actions from './crud_actions'

export const CLEAR_DRAFT = 'clear_draft'
export const PREPARE_DRAFT = 'prepare_draft'
export const TOUCHED_DRAFT = "TOUCHED_DRAFT"
export const clearDraft = opts => {
  return {
    type: CLEAR_DRAFT,
    payload: opts
  }
}

export const prepareDraft = opts => {
  return {
    type: PREPARE_DRAFT,
    payload: opts
  }
}

export const touchedDraft = opts => {
  return {
    type: TOUCHED_DRAFT, payload: opts
 
  }
}


export const addZoomToDraft = crud_actions.upsert('draft', 'zoomDraft')
export const loadDrafts = crud_actions.read('drafts')
export const loadDraft = crud_actions.read('draft', 'loadDraft')
export const deleteDraft = crud_actions.delete('draft')
export const upsertDraft = crud_actions.upsert('draft', 'upsertDraft')
export const loadUnpublishedDraft = crud_actions.read(
  'draft',
  'loadUnpublishedDraft'
)
export const publish = crud_actions.upsert('post', 'publish')
export const publishResponse = crud_actions.upsert('response', 'publish')
